import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { LanguageService } from '../../services/language.service'
import { LanguageWidget } from 'htv-lib'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'

@Component({
  selector: 'app-current-language',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './current-language.component.html',
  styleUrls: ['./current-language.component.scss'],
})
export class CurrentLanguageComponent extends DynamicTextComponent implements OnInit {
  url = ''
  override allowOverflow = true
  override enableVisibilityControl = true

  constructor(private languageService: LanguageService) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()

    const selectedLanguage = this.languageService.getSelectedLanguage()
    if (selectedLanguage) {
      this.text = selectedLanguage.nativeName
      this.url = `assets/images/flags/${selectedLanguage.code}.svg`
    } else {
      this.text = ''
      this.url = ''
    }
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as LanguageWidget
    const containerStyle: Record<string, string | number> = {}
    const iconStyle: Record<string, string | number> = {}

    if (config.fontSize) {
      const scaledFontSize = this.scaleToResolution(config.fontSize)
      iconStyle['height'] = `${scaledFontSize * 1.5}px`
      iconStyle['width'] = `${scaledFontSize * 1.5}px`
      iconStyle['margin-left'] = `${scaledFontSize * 0.5}px`
    }

    if (config.alignment) {
      switch (config.alignment) {
        case 'right':
          containerStyle['justify-content'] = `end`
          break
        case 'left':
          containerStyle['justify-content'] = `start`
          break
        default:
          break
      }
    }

    this.setRule('.container', containerStyle)
    this.setRule('.icon', iconStyle)
  }
}
